import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { asyncWrap } from '../utils/utils';
import { useAuth } from '../context/auth-context';

const PopupManager = ({ userId }) => {
  const [popups, setPopups] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    if (!userId) return;

    // 🔹 Fetch popups when user logs in
    const fetchPopups = async () => {
      //eslint-disable-next-line
      const [error, result] = await asyncWrap(axios.get('/popup'));

      if (!result) {
        console.log(`didn't got data from api`, error);
        return;
      }
      setPopups(result.data.data);
    };

    fetchPopups();
  }, [userId]);
  useEffect(() => {
    if (popups.length > 0) {
      showPopupsSequentially(popups);
    }
  }, [popups]);

  function convertToEmbedLink(url) {
    let videoId = "";

    // Case 1: Standard YouTube URL
    const standardMatch = url.match(/(?:\?v=|&v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/);

    if (standardMatch && standardMatch[1]) {
      videoId = standardMatch[1];
    }

    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    } else {
      return null; // Invalid YouTube link
    }
  }

  async function showPopupsSequentially(list) {
    for (const popup of list) {
      if (!shouldShowPopup(popup)) continue;

      const options = {
        title: popup.Title,
        confirmButtonText: 'Next',
        willClose: () => savePopupShown(popup), // ✅ Save when popup closes
      };

      const url = popup.URL.startsWith('http')
        ? popup.URL
        : popup.URL.replace(
            'sgp1.digitaloceanspaces.com/ut-lms',
            'https://ut-lms.sgp1.digitaloceanspaces.com'
          );

      switch (popup.Type) {
        case 'text':
          await Swal.fire({
            ...options,
            text: popup.TypeText,
          });
          break;
        case 'image':
          await Swal.fire({
            ...options,
            imageUrl: url,
            imageAlt: 'Popup Image',
          });
          break;
        case 'video':
          await Swal.fire({
            ...options,
            html: `<video width="100%" controls autoplay>
                   <source src="${url}" type="video/mp4" />
                 </video>`,
            width: '700px',
          });
          break;
        case 'video_url':
          await Swal.fire({
            ...options,
            html: `
      <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;border-radius:8px;">
        <iframe
          src="${convertToEmbedLink(popup.URL)}"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          style="position:absolute;top:0;left:0;width:100%;height:100%;">
        </iframe>
      </div>
    `,
            width: 800,
          });
          break;
        case 'pdf':
          await Swal.fire({
            ...options,
            html: `<iframe src="${popup.URL}" width="100%" height="400px"></iframe>`,
            width: '800px',
          });
          break;
        default:
          break;
      }
    }
  }

  function savePopupShown(popup) {
    console.log('Saving popup shown status for:', popup);
    const key = `popup_${popup.PopupID}`;
    const now = new Date();
    switch (popup.Frequency) {
      case 'everylogin':
        localStorage.setItem(key, 'shown');
        break;
      case 'everyday':
        localStorage.setItem(key, now.toDateString());
        break;
      case 'everyweek':
        localStorage.setItem(key, getWeekKey(now));
        break;
    }
  }

  function shouldShowPopup(popup) {
    const key = `popup_${popup.PopupID}`;
    const saved = localStorage.getItem(key);
    const now = new Date();
    if (!saved) return true;
    console.log('Saved popup status:', saved);
    switch (popup.Frequency) {
      case 'everylogin':
        return false;
      case 'everyday':
        return saved !== now.toDateString();
      case 'everyweek':
        return saved !== getWeekKey(now);
      default:
        return true;
    }
  }

  function getWeekKey(date) {
    const firstDay = new Date(date.getFullYear(), 0, 1);
    const pastDays = Math.floor((date - firstDay) / (24 * 60 * 60 * 1000));
    const week = Math.ceil((pastDays + firstDay.getDay() + 1) / 7);
    return `${date.getFullYear()}-W${week}`;
  }

  return null;
};

export default PopupManager;